import handler from 'api/handler'

const prefix = '/public/featuredPlacement'

const methods = {
  fetch: args => handler({ method: 'get', url: prefix + '/fetch', args })
}

export default methods
